/* Canapuff mega menu v15 – behaviour of the desktop bar (snippets/mm15-desktop.liquid) and of the drawer content
   (snippets/mm15-drawer.liquid). No dependencies. Desktop: hover intent, click / Enter, Esc, focus-out, outside click.
   Drawer: level 2 built from <template> on first tap, Back restores the level-1 scroll position, reset when the drawer closes. */
(function () {
  'use strict';
  var DESK = window.matchMedia('(min-width: 1150px)');

  /* ---------------- desktop ---------------- */
  function initDesktop(root) {
    if (!root || root.__mm15) return; root.__mm15 = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mm15-tab]'));
    var tOpen, tClose;
    function btn(li) { return li.querySelector('.mm15-tab-b'); }
    function setTop() {
      var r = root.getBoundingClientRect();
      document.documentElement.style.setProperty('--mm15-top', Math.max(0, Math.round(r.bottom)) + 'px');
    }
    function close(li) { li.classList.remove('is-open'); btn(li).setAttribute('aria-expanded', 'false'); }
    function closeAll() { tabs.forEach(close); }
    function open(li) {
      tabs.forEach(function (o) { if (o !== li) close(o); });
      setTop(); li.classList.add('is-open'); btn(li).setAttribute('aria-expanded', 'true');
    }
    tabs.forEach(function (li) {
      btn(li).addEventListener('click', function (e) {
        e.stopPropagation();
        if (li.classList.contains('is-open')) close(li); else open(li);
      });
      li.addEventListener('mouseenter', function () {
        if (!DESK.matches) return; clearTimeout(tClose); clearTimeout(tOpen);
        var other = root.querySelector('.mm15-tab.is-open');
        tOpen = setTimeout(function () { open(li); }, other ? 60 : 120);
      });
      li.addEventListener('mouseleave', function () {
        if (!DESK.matches) return; clearTimeout(tOpen);
        tClose = setTimeout(function () { close(li); }, 250);
      });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(li); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('[data-mm15]')) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var o = root.querySelector('.mm15-tab.is-open'); if (!o) return;
      close(o); btn(o).focus();
    });
    window.addEventListener('scroll', function () { if (root.querySelector('.mm15-tab.is-open')) setTop(); }, { passive: true });
    DESK.addEventListener && DESK.addEventListener('change', closeAll);
  }

  /* ---------------- drawer ---------------- */
  function initDrawer(root) {
    if (!root || root.__mm15) return; root.__mm15 = true;
    var l1 = root.querySelector('[data-mm15-l1]'), l1Scroll = 0, opener = null, anc = [];
    function panel(i) {
      var p = root.querySelector('[data-mm15-panel="' + i + '"]');
      if (!p) {
        var tpl = root.querySelector('template[data-mm15-l2="' + i + '"]');
        if (!tpl) return null;
        root.appendChild(document.importNode(tpl.content, true));
        p = root.querySelector('[data-mm15-panel="' + i + '"]');
      }
      return p;
    }
    function back(focusOpener) {
      var o = root.querySelector('.mm15d-l2.is-open'); if (o) o.classList.remove('is-open');
      root.classList.remove('in-l2'); anc.forEach(function (x) { x[0].scrollTop = x[1]; }); anc = []; l1.scrollTop = l1Scroll;
      if (opener) { opener.setAttribute('aria-expanded', 'false'); if (focusOpener !== false) opener.focus({ preventScroll: true }); }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mm15-open]');
      if (b) {
        var p = panel(b.getAttribute('data-mm15-open')); if (!p) return;
        l1Scroll = l1.scrollTop; opener = b; b.setAttribute('aria-expanded', 'true');
        p.scrollTop = 0; p.classList.add('is-open'); root.classList.add('in-l2');
        /* iOS / theme drawer: if an outer container is scrolled, level 2 (absolute, top of the panel) would open out of view */
        anc = []; for (var a = root; a && a !== document.documentElement; a = a.parentElement) { if (a.scrollTop > 0) { anc.push([a, a.scrollTop]); a.scrollTop = 0; } }
        var bk = p.querySelector('.mm15d-bar [data-mm15-back]'); if (bk) bk.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-mm15-back]')) back();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('in-l2')) { e.stopPropagation(); back(); }
    }, true);
    var drawer = root.closest('navigation-drawer');
    if (drawer) drawer.addEventListener('dialog:after-hide', function () { back(false); l1.scrollTop = 0; });
  }

  function init() {
    document.querySelectorAll('[data-mm15]').forEach(initDesktop);
    document.querySelectorAll('[data-mm15-drawer]').forEach(initDrawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
